import React, { FC } from 'react';
import { useIsMobile } from 'WindowDimensionProvider';
import EventCoverMediaDesktop from './EventCoverMediaDesktop';
import EventCoverMediaMobile from './EventCoverMediaMobile';

interface Props {
  scrollAnimationDelay?: number;
  selectedMediaIndex: number;
  setSelectedMediaIndex: (index: number) => void;
  brandFlagName?: string | null;
}

const EventCoverMedia: FC<Props> = ({
  scrollAnimationDelay = 0,
  selectedMediaIndex,
  setSelectedMediaIndex,
  brandFlagName,
}) => {
  const isMobile = useIsMobile();
  if (isMobile) {
    return (
      <EventCoverMediaMobile
        scrollAnimationDelay={scrollAnimationDelay}
        selectedMediaIndex={selectedMediaIndex}
        setSelectedMediaIndex={setSelectedMediaIndex}
        brandFlagName={brandFlagName}
      />
    );
  }
  return (
    <EventCoverMediaDesktop
      scrollAnimationDelay={scrollAnimationDelay}
      brandFlagName={brandFlagName}
    />
  );
};

export default EventCoverMedia;
